import React, { useEffect } from 'react';
import axios from "../../utils/config-axios";
import {oktaLogout} from "../../utils/okta-utils";

/**
 * Used to track logouts when a user closes a browser tab or window.
 */
function WindowCloseListener({ children }) {
    useEffect(() => {
        const handleUnload = () => {

            axios({
                url: '/api/private/home/logout',
                method: 'GET',
            }).catch((logoutErr)=>{
                console.log("Logout Issue", logoutErr);
            });

            //
            // Firebase is session based so if the window is closed,
            // the session is killed. No need to logout for Firebase.
            //

            //
            // Logout of Okta.
            //
            oktaLogout(false, null, null).then(()=>{
                //console.log("Logged out of Okta...")
            }).catch(error=>{
                console.log("Failed to logout of Okta", error)
            });
        };

        window.addEventListener('unload', handleUnload);

        return () => {
            window.removeEventListener('unload', handleUnload);
        };
    }, []);

    return <>{children}</>;
}

export default WindowCloseListener;
